import './../../../scss/app.scss';
import './../../../utils/state';
import StateModule from "./../../../utils/state";

StateModule.loadInitialData();

const loc = window.location.href;
const CRM_ACCOUNT_ID = StateModule.store.CRMId;

if (loc.indexOf("purchaserulemgmt") > -1) {
    import("./../../account/purchase_management/index.js").then(module => {
        $(function() {
            let page = new module.default('#purchase_rule_management_container');
            page.init();
        })
    })
}

if (loc.indexOf("/account/password.html") > -1) {
    import("./../../account/password/index.js").then(module => {
        $(function() {
            let page = new module.default('.manage-account');
            page.init();
        })
    })
}

if (loc.indexOf("/site/account/") > -1) {
    import("./../../account/address_body/index.js").then(module => {
        $(function() {
            let page = new module.default('.account-address');
            page.init();

            window.setOldBillingAddress = page.setOldBillingAddress.bind(page);
        })
    })
}

// ACCOUNT CUSTOMIZATION

/*
CRM Account # 3404463
Oracle Acct ID:  300207853
*/
if (
    loc.indexOf("/site/expressemailquote/index.html") > -1 && 
    CRM_ACCOUNT_ID === 3404463
) {
    import('./account_3404463/express_email_quote/index.js');
}

/*
Account ID: 2754944
Web ID: 300176702
*/
if (
    (loc.indexOf("/site/standard_page/index.html") > -1 || 
    loc.indexOf("/site/locate/search.html") > -1 || 
    loc.indexOf("/site/cart/index.html") > -1 || 
    loc.indexOf("/site/product/index.html") > -1) && 
    CRM_ACCOUNT_ID === 2754944
) {
    import('./account_2754944/index.js')
}

/*
Account # 3910737
Account ID: 300177103
*/
if (
    loc.indexOf("/site/standard_page/index.html") > -1 && 
    CRM_ACCOUNT_ID === 3910737
) {
    import('./account_3910737/standard_page/index.js');
}

/*
Account # 866897
Web ID: 300261475
*/
if (CRM_ACCOUNT_ID === 866897) {
    import('./account_866897/index.js');
}

export default class ZonesPage {

    constructor() {
        this.account_id = -1;
    }

    bootstrap() {
        let self = this;

        self.import_files(self.account_id)
    }

    setAccountId(account_id) {
        return this.account_id = account_id;
    }

    getAccountId() {
        return this.account_id;
    }

    import_files(account_id) {
        
        // APPLY TO ALL PAGES
        loadProductPage();
        
        if (CRM_ACCOUNT_ID != -1) {
            loadZonesConnectDesign();
        }

        switch(account_id) {
            default: {
                break;
            }
        }
    }
}

const loadZonesConnectDesign = () => {
    if (document.location.href.indexOf("standard_page") > -1) {
        $(document.body).addClass('gray-background');
        
        import("./../../standard/std_page/index.js").then(module => {
            let page = new module.default('.standards-page');
            page.init();
        });
    }

    if (document.querySelector("#zc-sidebar")) {
        import('./../../account/account_right/acct_542493/index.js').then(module => {
            let page = new module.default("#zc-sidebar", CRM_ACCOUNT_ID);
            window.p = page;
            page.init();
            page.show_page();
        })
    }
}

const loadProductPage = () => {
    if (window.location.href.indexOf("/product/index.html") > -1) {

        import("./../../product/product_page_business/index.js").then(module => {
            let page = new module.default('#body', 82,5);
            //page.stateListener();
            page.renderProductImage();
            page.pageInit();
        })
    }
}

$(function() {
    const zpage = new ZonesPage();
    const accountId = StateModule.store.CRMId;

    if (accountId != -1) zpage.setAccountId(accountId);
    
    zpage.bootstrap();
})
